import { Navigate } from 'react-router-dom';
import LoadingScreen from '@/components/LoadingScreen';
import useAuth from '@/hooks/useAuth';
import navConfig from '@/layouts/dashboard/navbar/NavConfig';
import Page403 from '@/pages/Page403';
import { getDefaultNavPath } from '@/utils/permissions';

export default function DefaultRedirect() {
  const { isInitialized, permissions, isSuperAdmin } = useAuth();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  const defaultPath = getDefaultNavPath(
    navConfig,
    permissions,
    isSuperAdmin
  );

  if (!defaultPath) {
    return <Page403 />;
  }

  return <Navigate to={defaultPath} replace />;
}
